import React, { useContext } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { colors } from '@mobi/component-library/Foundations'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { TeamShieldColorsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon/Components/TeamIcon/Components/Common/TeamColorShield'
import { TeamIconContext } from '@mobi/sports-offering/Components/Common/TeamsIcon/Components/TeamIcon/TeamIconProvider'

export const DefaultIcon: React.FC<{
  defaultIconType: DefaultIconType
  sportName?: KambiSportName
  size: string
}> = ({ sportName, defaultIconType, size }) => {
  const { shouldLoadDefaultIcon } = useContext(TeamIconContext)
  if (!shouldLoadDefaultIcon) return null

  if (defaultIconType === 'sport-icon' && sportName) {
    return <SportsIcon size={size} sport={sportName} />
  }

  if (defaultIconType === 'team-icon') {
    return (
      <TeamShieldColorsIcon
        size={size}
        colors={{ team: '', mainColor: colors.white, secondaryColor: '#EDEDED' }}
      />
    )
  }

  return null
}

//=========
// Types
//=========

export type DefaultIconType = 'sport-icon' | 'team-icon' | null
